import React, { useRef, useState } from 'react';
import emailjs from 'emailjs-com';
import './Contact.css';
import Navbar from './Navbar';
import SiteFooter from './SiteFooter';
import ReCAPTCHA from 'react-google-recaptcha';
import { contactNote } from './contactContent';

function Contact() {
  const captcha = useRef(null);
  const [sending, setSending] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [formData, setFormData] = useState({
    user_name: '',
    user_email: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    if (sending) return;
    if (!captchaVerified) {
      setFeedback('Please complete the CAPTCHA verification.');
      return;
    }
    const form = e.currentTarget;
    setSending(true);
    setFeedback('Sending your message…');
    try {
      await emailjs.sendForm('service_kkadc71', 'template_19w5bfn', form, 'j1QF5huCh3hoBa7Ei');
      setFormData({ user_name: '', user_email: '', message: '' });
      setFeedback('Message sent. Thank you for getting in touch!');
    } catch {
      setFeedback('Your message could not be sent. Please try again or email contact@voidmaw.com.');
    } finally {
      setSending(false);
      setCaptchaVerified(false);
      captcha.current?.reset();
    }
  };

  const onCaptchaChange = (value) => setCaptchaVerified(Boolean(value));

  return (
    <>
      <div className="contact-page">
        <Navbar />
        <div className='contact-container'>
          <h1>Contact</h1>
          <p>Discord: katanaut</p>
          <div className="contact-notes">
            <p>{contactNote} <a href="mailto:contact@voidmaw.com">contact@voidmaw.com</a>.</p>
          </div>
          <form className="contact-form" onSubmit={sendEmail} aria-busy={sending}>
            <label className="contact-field" htmlFor="user_name">
              <span>Your Name</span>
              <input id="user_name" type="text" name="user_name" autoComplete="name" value={formData.user_name} onChange={handleChange} readOnly={sending} required />
            </label>
            <label className="contact-field" htmlFor="user_email">
              <span>Your Email</span>
              <input id="user_email" type="email" name="user_email" autoComplete="email" value={formData.user_email} onChange={handleChange} readOnly={sending} required />
            </label>
            <label className="contact-field" htmlFor="message">
              <span>Your Message</span>
              <textarea id="message" name="message" value={formData.message} onChange={handleChange} readOnly={sending} required />
            </label>
            <ReCAPTCHA
              ref={captcha}
              sitekey="6LcDH18qAAAAAPtVhv8PvhmYPUFyj_oOzdHD1p0X"
              onChange={onCaptchaChange}
              onExpired={() => setCaptchaVerified(false)}
              onErrored={() => setCaptchaVerified(false)}
            />
            <button type="submit" disabled={sending}>{sending ? 'Sending…' : 'Send'}</button>
            <p className="contact-feedback" role="status" aria-live="polite" aria-atomic="true">{feedback}</p>
          </form>
        </div>
        <SiteFooter showContact={false} />
      </div>
    </>
  );
}

export default Contact;
